import React from 'react'
import { lock } from '../../utils/images/imagepath'
import { Link, useNavigate } from 'react-router-dom'

const AccessDenied = () => {
  const navigate = useNavigate()
  return (
    <div className='accessDenied_golb'>
      <div className='accessDenied_body'>
        <img className='lock' src={lock} />
        <div className='message text-center'>
          <h1>Access to this page is restricted</h1>
          <p>Please check with the site admin.</p>
          <button
            type='button'
            className='btn btn-save'
            onClick={() => navigate(-1)}
          >
            Go back
          </button>
        </div>
      </div>
    </div>
  )
}

export default AccessDenied
